import QuoteForm from './QuoteForm';

export default function Location() {
  return (
    <section id="location" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-rajdhani font-bold text-4xl md:text-5xl text-white mb-4">
            Visit Us Today
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="space-y-8">
            <div>
              <h3 className="font-rajdhani font-bold text-2xl text-white mb-4 flex items-center gap-3">
                <i className="ri-map-pin-line text-red-600"></i>
                Address
              </h3>
              <address className="text-white/80 text-lg not-italic leading-relaxed">
                3181 Wolfedale Rd, Unit 9<br />
                Mississauga, Ontario<br />
                Canada
              </address>
            </div>

            <div>
              <h3 className="font-rajdhani font-bold text-2xl text-white mb-4 flex items-center gap-3">
                <i className="ri-phone-line text-red-600"></i>
                Phone
              </h3>
              <a
                href="tel:905-226-0408"
                className="text-white text-2xl font-bold hover:text-red-600 transition-colors cursor-pointer"
              >
                905-226-0408
              </a>
            </div>

            <div>
              <h3 className="font-rajdhani font-bold text-2xl text-white mb-4 flex items-center gap-3">
                <i className="ri-time-line text-red-600"></i>
                Business Hours
              </h3>
              <div className="text-white/80 text-lg space-y-2">
                <div className="flex justify-between">
                  <span>Monday - Friday:</span>
                  <span className="font-semibold">9:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday:</span>
                  <span className="font-semibold">9:00 AM - 5:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday:</span>
                  <span className="font-semibold">Closed</span>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="rounded-2xl overflow-hidden shadow-2xl border-2 border-red-600 h-[500px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2890.123456789!2d-79.6441!3d43.5890!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDPCsDM1JzIwLjQiTiA3OcKwMzgnMzguOCJX!5e0!3m2!1sen!2sca!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="N.A. Discount Auto Parts Location"
              ></iframe>
            </div>
          </div>
        </div>

        <QuoteForm />
      </div>
    </section>
  );
}
